/*
 * Copyright © 2026 MS IMAGES. All rights reserved.
 * Proprietary and confidential — unauthorized copying, distribution, or use
 * of this file, via any medium, is strictly prohibited. See LICENSE.
 */

import { useTranslation } from 'react-i18next';
import { useServiceWorkerUpdate } from '@/lib/pwa/useServiceWorkerUpdate';

export function UpdatePrompt() {
  const { needRefresh, update, close } = useServiceWorkerUpdate();
  const { t } = useTranslation('core');
  if (!needRefresh) return null;
  return (
    <div className="pwa-update" role="alert">
      <span>{t('pwa.updateAvailable')}</span>
      <div className="pwa-update-actions">
        <button className="pwa-update-reload" onClick={update}>{t('pwa.reload')}</button>
        <button className="pwa-update-dismiss" onClick={close}>{t('pwa.dismiss')}</button>
      </div>
      <style>{`
        .pwa-update {
          position: fixed; right: 1rem; bottom: 1rem; z-index: 1001;
          display: flex; flex-direction: column; gap: 0.5rem;
          padding: 0.85rem 1rem; max-width: 320px;
          background: var(--color-bg-secondary);
          border: 1px solid var(--color-border-subtle);
          border-radius: var(--radius-lg); box-shadow: var(--shadow-lg);
          color: var(--color-text-primary); font-family: var(--font-body); font-size: 0.85rem;
        }
        .pwa-update-actions { display: flex; gap: 0.5rem; justify-content: flex-end; }
        .pwa-update-reload {
          padding: 0.35rem 0.75rem; border: none; border-radius: var(--radius-md);
          background: var(--color-brand-primary); color: #fff; cursor: pointer;
        }
        .pwa-update-reload:hover { background: var(--color-brand-primary-hover); }
        .pwa-update-dismiss {
          padding: 0.35rem 0.75rem; border: 1px solid var(--color-border-default);
          border-radius: var(--radius-md); background: transparent;
          color: var(--color-text-secondary); cursor: pointer;
        }
      `}</style>
    </div>
  );
}
